import { Component, OnInit } from "@angular/core";
import { AlertService } from "../_services";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AbstractControl,
  FormBuilder,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { OnboardOrganizationService } from "../_services/onboard-organization.service";

@Component({
  selector: "app-onboard-organization-view",
  templateUrl: "./onboard-organization-view.component.html",
  styleUrls: [],
})
export class OnboardOrganizationViewComponent implements OnInit {
  partner_status: any;
  remarkForm: any;
  showloding = true;
  lodingImage = false;
  urlParams: any;
  api_error: any;
  is_Error: boolean = false;
  errorMessage: string | null = null;
  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private dataService: OnboardOrganizationService,
    private fb: FormBuilder
  ) {}

  partner = {
    partner_remarks: "",
  };

 onboardOrg = {
  id: "",
  name: "",
  type: "",
  slug: "",
  website: "",
  contact_info: "",
  address: "",
  state: "",
  district: "",
  service_provider_id: "",
  short_description: "",
  startup_stage_support: "",
  focus_sector: "",
  eligibility_criteria: "",
  mode_of_delivery: "",
  duration: "",
  link_to_brochure: "",
  details_of_service: "",
  pricing_model: "",
  status: "",
  type_others: "",
  service_provider_others: "",
  startup_stage_support_others: "",
  eligibility_criteria_others: "",
  eligibility_criteria_threshold: "",
  pricing_model_others: "",
  focus_sector_others: "",
  approve_status: "",
  reject_remarks: "",
  approved_rejected_date: "",
  approved_rejected_by: "",
  state_name: "",
  district_name: "",
  service_provider_name: "",
  service_provider_slug: "",
  type_name: "",
  startup_stage_support_name: "",
  focus_sector_name: "",
  eligibility_criteria_name: "",
  mode_of_delivery_name: "",
  pricing_model_name: ""
};


 

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.urlParams = params["id"];
    });

    this.remarkForm = this.fb.group({
      remarks: ["", [Validators.required, this.noWhitespaceValidator()]],
    });
    this.getOnboardingDetails();
  }

  get remarks() {
    return this.remarkForm.get("remarks");
  }

  getOnboardingDetails() {
    this.loadShow();

    this.dataService
      .viewServiceProvider(this.urlParams)
      .pipe()
      .subscribe((res) => {
        if (res["status"] == 200)
          this.onboardOrg = res['data']

        this.loadHide();
      });
  }

  saveSubmit(status: any) {
    this.errorMessage = "";
    this.loadShow();

    const data = {
      id: this.urlParams,
      status: status,
      remarks: this.remarkForm.value.remarks
        ? this.remarkForm.value.remarks
        : "",
    };
    this.dataService
      .updateOnboardOrg(data)
      .pipe()
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            this.alertService.success(res["mesg"], true);

            window.scroll(0, 0);

            this.loadHide();
            setTimeout(() => {
              this.router.navigate(["onboard-organization"]);
            }, 1000);
          } else if (res["status"] == 422) {
            this.loadHide();
            this.is_Error = true;
            this.api_error = res['errors']['remarks'];
            setTimeout(() => {
              this.api_error = "";
            }, 3000);
          }
        },
        (error) => {
          this.alertService.error(error);
          this.loadHide();
        }
      );
  }

  onBack() {
    this.router.navigate(["/onboard-organization"]);
  }

  noWhitespaceValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || "").trim().length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }
  

  rejectStatus(status) {
    if (this.remarkForm.invalid) {
        this.remarkForm.markAllAsTouched();
    } else {
        this.saveSubmit(status);
    }
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
